/*  
    AI Suggest Container - 
    This is where the the AI Suggest store state is connected to the view and then kicks off the rendering of the react module.
    All events flow through this file.
*/

import PropTypes from "prop-types";
import React from "react";
import AbstractionAiModule
    from "lib/dataentry/lib/abstractionai/AbstractionAiModule";
import ActiveFormStore from "data/ActiveFormStore";
import EntityFieldMetaStore from "data/meta/entityFieldMetaStore";
import AbstractionAiStore from "data/meta/AbstractionAiStore";
import NavigationActions from "data/NavigationActions";
import useFluxStore from "@armus/use-flux-store";
import safeContextDispatch from "data/util/safeContextDispatch";
import entityMetaStore from "data/meta/entityMetaStore";
import AbstractionAiActions from "data/meta/AbstractionAiActions";
import HybridConfig from "lib/HybridConfig";

const AbstractionAiContainer = props => {
    const ctx = props.fluxContext;
    const state = useFluxStore(() => {
        const ctrl = ActiveFormStore.getActiveControl(ctx);
        const next = {};
        if (ctrl == null) return next;
        const fieldInfo = EntityFieldMetaStore.getInfo(ctrl.entityKey, ctrl.fieldKey);
        const lo = AbstractionAiStore.getAbstractionAiSuggestLO(
            ctx,
            ctrl.entityKey,
            ctrl.fieldKey
        );
        if (lo.hasValue()) {
            Object.assign(next, lo.getRequiredValue());
        }
        if(lo.hasError()) {
            Object.assign(next, {error: true});
        }
        next.feedbackEnabled = HybridConfig.get(`aiAnalytics.enabled`, false);
        next.key = ctrl.entityKey + ctrl.fieldKey;
        next.isLoading = lo.isLoading();
        next.shortName = ctrl.fieldKey;
        next.name = fieldInfo.name;
        next.keyboardShortcuts = ctrl.keyboardShortcuts;
        next.getFieldLabel = (entityKey, fieldKey) => (
             EntityFieldMetaStore.getInfo(entityKey, fieldKey).name
        );
        next.getEntityLabel = (entityKey) => (
            entityMetaStore.getInfo(entityKey).name
        );
        next.onNavToField = (entityKey, recordId, fieldKey) => {
            safeContextDispatch(ctx, {
                type: NavigationActions.SELECT_RECORD,
                entityKey,
                recordId,
                fieldKey,
            });
        };
        next.onFeedback = (evidenceId, feedback) => {
            safeContextDispatch(ctx, {
                type: AbstractionAiActions.FEEDBACK,
                evidenceId,
                feedback,
            });
        };

        next.getFeedback = (evidenceId) =>
            (AbstractionAiStore.getFeedback(ctx, evidenceId));
        return next;
    }, [
        ActiveFormStore,
        AbstractionAiStore,
        EntityFieldMetaStore
    ], [ctx]);
    return <AbstractionAiModule {...state} open={props.open} onToggleOpen={props.onToggleOpen} />;
};

AbstractionAiContainer.propTypes = {
    fluxContext: PropTypes.string.isRequired,
    open: PropTypes.any,
    onToggleOpen: PropTypes.func.isRequired,
};

export default AbstractionAiContainer;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/abstractionai/AbstractionAiContainer.js